import UpdateDocsPage from './UpdateDocsPage';

export default UpdateDocsPage;



// WEBPACK FOOTER //
// ./src/components/UpdateDocsPage/index.js